export const thumbnailStyles = [
  'button-thumbnail-style-01',
  'button-thumbnail-style-02',
  'button-thumbnail-style-03',
];
